(function() {  
  
  function vh(v) {
    var h = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    return (v * h) / 100;
  }

  function vw(v) {
    var w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    return (v * w) / 100;
  }

  function vmin(v) {
    return Math.min(vh(v), vw(v));
  }

  function vmax(v) {
    return Math.max(vh(v), vw(v));
  }
  
  var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
  
     gsap.to(".floatyGrapeHeroTop", 
         {
       	  delay:1,
          duration: 3,
          y: 800,
        },
      );
             
      gsap.to(".floatyGrapeHeroBottom", 
         {
          delay:1,   
          duration: 3,
          y: 800,
        },
      );

      gsap.fromTo(".fineWineHeader .sectionTitle.fineWineTitle", 
         {
          duration: 1,
          x: vw(-50)
        }, 
                    {
          duration: 1, 
          x: vw(5)
        }
      );
    
      gsap.fromTo(".collectionHeader", 
         {
          duration: 1,
          x: vw(-50)
        }, 
                    {
          duration: 1, 
          x: vw(2)
        }
      );
    
      gsap.fromTo(".aboutUsHeader .sectionTitle.fineWineTitle", 
        {
          duration: 0.7,
          x: vw(-20)
        }, 
                    {
          duration: 0.7,   
          x: vw(2)
        }
      );
    
      gsap.fromTo(".faqHeader .sectionTitle.faqTitle", 
        {
          duration: 0,
          scrollTrigger: {
            toggleActions: "play",
          },
          x: vw(-50)
        }, 
                    {
          duration: 2,
          scrollTrigger: {
            toggleActions: "play",
          },   
          x: vw(5)
        }
      );
    
      gsap.fromTo(".faqBottom .sectionTitle.faqTitleB", 
        {
          duration: 1,
          scrollTrigger: {
            toggleActions: "play pause resume reverse",
          },
          x: vw(-50)
        }, 
                    {
          duration: 1,
          scrollTrigger: {
            toggleActions: "play pause resume reverse",
          },   
          x: vw(-10)
        }
      );
    
      gsap.fromTo(".tradeSectionOne .sectionTitle.faqTitle", 
        {
          duration: 1,
          x: vw(-50)
        }, 
                    {
          duration: 1,
          x: vw(6)
        }
      );
    
      gsap.fromTo(".largeGrapes img", 
        { 
          y: -450
        }, 
        {
          duration:0.7,	
          delay: 1.5,
          y: 50
        }
      );
    
      gsap.fromTo("#shopify-section-product-recommendations .sectionTitle.recTitle", 
        { 
          scrollTrigger: {
              toggleActions: "play pause resume reverse",
          },
          x: vw(-50)
        }, 
        {
          scrollTrigger: {
              toggleActions: "play pause resume reverse",
          },
          x: 0
        }
      );

      gsap.fromTo("#shopify-section-three-across-product-page .sectionTitle.titleHPFour", 
        { 
          scrollTrigger: {
              toggleActions: "play pause resume reverse",
          },
          x: vw(-50)
        }, 
        {
          scrollTrigger: {
              toggleActions: "play pause resume reverse",
          },
          x: vw(-14)
        }
      );
  
  		/* ------- */
  
      gsap.fromTo(".blogListingSliderTitle", 
        {
          duration: 1,
          x: vw(-50)
        }, 
                    {
          duration: 1, 
          x: vw(1)
        }
      );

  
  

  
  	if (jQuery(window).width() >= 768) {
        gsap.fromTo(".heroTextTop", 
                    { 
          duration: 1,
          scrollTrigger: {
          },
          x: -60
        },
                    {
          scrollTrigger: {
          },
          x: 0
        }
      );
    } else {
      gsap.to(".heroTextTop", 
          { 
        	x:70,
        	duration:1,
        	delay:0.7,
          }
      );
    }
  	
  	if (jQuery(window).width() >= 768) {
      gsap.fromTo(".heroTextBottom", 
                  { 
        duration: 1,
        scrollTrigger: {
        },
        x: -60 
      }, 
                  {
        opacity: 1, 
        scrollTrigger: {
        },   
        x: 0 
      }
    );
    } else {
      gsap.to(".heroTextBottom", 
          { 
        	x:0,
        	duration:1,
        	delay:0.7,
          }
      );
    }
  
      gsap.fromTo(".titleHPTwo", 
        { 
          duration: 0.5,
          scrollTrigger: {
          },
          x: -150
        }, 
        {
          scrollTrigger: {
            trigger: ".titleHPTwo",
            start: "center center"
          },   
          x: 0 
        }
      );

      gsap.fromTo("#pukka-img", 
        { 
          duration: 0.5,
          scrollTrigger: {
          },
          x: -100 
        }, 
        {
          scrollTrigger: {
            trigger: ".titleHPTwo",
            start: "center center"
          },   
          x: 0 
        }
      );
  
  
      gsap.fromTo("#pukka-arrow-text", 
        { 
          duration: 1,
          scrollTrigger: {
          },
          y: -100 
        }, 
        {
          scrollTrigger: {
            trigger: "#pukka-img",
            start: "bottom bottom"
          },   
          y: 0 
        }
      );
  
  		gsap.fromTo("#pukka-arrow", 
        { 
          duration: 1,
          scrollTrigger: {
          },
          x: 100 
        }, 
        {
          scrollTrigger: {
            trigger: "#pukka-img",
            start: "bottom bottom"
          },   
          x: 0 
        }
      );
  
  	gsap.fromTo(".thirdSectionTitle", 
        { 
          duration: 0.5,
          scrollTrigger: {
          },
          x: -100 
        }, 
        {
          scrollTrigger: {
            trigger: ".thirdSectionTitle",
            start: "center center"
          },   
          x: 0 
        }
      );
  
    	gsap.fromTo(".treeAcrossGrape", 
        { 
          scrollTrigger: {
            toggleActions: "play pause resume reverse",
          	scrub: 0.5
          },
          y: -250 
        }, 
        {
          scrollTrigger: {
            trigger: ".treeAcrossGrape",
            toggleActions: "play pause resume reverse",
          	scrub: 0.5,
            start: "center center"
          },   
          y: 50 
        }
      );
  
      	gsap.fromTo(".treeAcrossGrapeBottom", 
        { 
          scrollTrigger: {
            toggleActions: "play pause resume reverse",
          	scrub: 0.5
          },
          y: -50
        }, 
        {
          scrollTrigger: {
            trigger: ".titleHPFour",
            toggleActions: "play pause resume reverse",
          	scrub: 0.5,
            start: "center center"
          },   
          y: 50 
        }
      );
  
  		gsap.fromTo(".titleHPFour", 
        { 
          duration: 0.5,
          scrollTrigger: {
          },
          x: 100
        }, 
        {
          opacity: 1,
          scrollTrigger: {
            trigger: ".titleHPFour",
            start: "center center"
          },   
          x: 0
        }
      );
  
  		gsap.fromTo(".bottomSectionHP", 
        { 
          duration: 0.5,
          scrollTrigger: {
          },
          x: -300
        }, 
        {
          scrollTrigger: {
            trigger: ".bottomSectionHP",
            start: "center center"
          },   
          x: 0
        }
      );
  
  		gsap.fromTo("#about-right", 
        { 
          duration: 0.5,
          scrollTrigger: {
          },
          x: 100 
        }, 
        {
          scrollTrigger: {
            trigger: ".bottomSectionHP",
            start: "center center"
          },   
          x: 0 
        }
      );
  
        gsap.fromTo("#about-left", 
        { 
          duration: 0.5,
          scrollTrigger: {
          },
          x: -100 
        }, 
        {
          scrollTrigger: {
            trigger: ".bottomSectionHP",
            start: "center center"
          },   
          x: 0 
        }
      );
  
  
  gsap.fromTo(".berriesFooter img", 
        { 
          scrollTrigger: {
            toggleActions: "play pause resume reverse",
          	scrub: 0.5
          },
          x: 150
        }, 
        {
          scrollTrigger: {
            trigger: "#about-left",
            toggleActions: "play pause resume reverse",
            start: "center center"
          },   
          x: 0 
        }
      );
  
          gsap.fromTo(".contactHeader .sectionTitle.faqTitle", 
                      {
            duration: 1,
            x: vw(-50)
          }, 
                      {
            duration: 1,
            x: vw(0)
          }
         );

})();